<template>
  <div class="inline_edit-norm">
    <v-container>
      <v-row>
        <v-col
          cols="12"
          md="4"
          v-for="field in params.fields"
          :key="field.name"
        >
          <v-text-field
            v-if="field.type == 'article'"
            v-model="fieldValues[field.name]"
            :label="field.label"
            required
            outlined
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="12">
          <v-btn @click="save" small outlined color="primary">
            {{ $t('Сохранить') }}
          </v-btn>
          <v-btn @click="cancel" class="ml-2" small outlined>
            {{ $t('Отмена') }}
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
  export default {
    props: {
      params: Object
    },
    data: () => ({
      load: false,
      fieldValues: {},
      referensValues: {},
      baseUrl: process.env.VUE_APP_BACK_URL
    }),
    mounted() {
      let self = this

      this.params.fields.forEach(function (field) {
        self.$set(self.fieldValues, field.name, field.value)
      })
    },
    methods: {
      selectIdPreferences(name) {
        this.fieldValues[name] = this.referensValues[name].id
      },
      save() {
        this.$emit('update-field', { status: true, value: this.fieldValues['number'] })
      },
      cancel() {
        this.$emit('update-field', { status: false })
      }
    }
  }
</script>
<style lang="scss">
  .inline_edit-norm {
    width: 100%;

    .v-input {
      padding-top: 10px;
    }
  }
</style>
